/* eslint-disable prettier/prettier */
/* eslint-disable import/order */

import { registry } from "@nextgisweb/webmap/panel/registry";
import * as p1 from "@nextgisweb/webmap/panel/annotations/plugin";
import * as p2 from "@nextgisweb/webmap/panel/bookmarks/plugin";
import * as p3 from "@nextgisweb/webmap/panel/description/plugin";
import * as p4 from "@nextgisweb/webmap/panel/identify/plugin";
import * as p5 from "@nextgisweb/webmap/panel/layers/plugin";
import * as p6 from "@nextgisweb/webmap/panel/print/plugin";
import * as p7 from "@nextgisweb/webmap/panel/search/plugin";
import * as p8 from "@nextgisweb/webmap/panel/share/plugin";
import * as p9 from "@nextgisweb/cadaster/webmap/panel/plugin";
import * as p10 from "@nextgisweb/tracker/trackers-panel/plugin";

export * from "@nextgisweb/webmap/panel/registry";

registry.seal();

[p1, p2, p3, p4, p5, p6, p7, p8, p9, p10];
